import { useProductDetailContext } from '@containers/ProductDetailContainer/ProductDetailContext';
import { useApolloClientHeaders } from '@hooks/useApolloClientHeaders';

import { skaCountryConfig } from '../lib/utils';

export const useIsSkinAnalyzerVisible = () => {
  const productContext = useProductDetailContext(false);
  const { shopId } = useApolloClientHeaders();

  const shouldShowSkinAnalyzer = Boolean(
    productContext &&
      productContext?.product?.features?.skinAnalyzer &&
      skaCountryConfig[shopId]
  );

  return shouldShowSkinAnalyzer;
};
